import React, { useState } from 'react';
import { Box } from '@mui/material';
import { AwsTemplate } from '../infrastructure/aws/aws-template';
import { AwsInstances } from '../infrastructure/aws/aws-instance';
import { CfInfrastructure } from '../infrastructure/cloudflare/cf-infrastructure';
import { GoogleAdsense } from '../infrastructure/google/google-adsense';
import { PillTabs } from '..';

const AWS_TABS = [
    { value: 'dashboard', label: 'Instances' },
    { value: 'templates', label: 'Templates' },
];

const CF_TABS = [
    { value: 'workers', label: 'Pages & Workers' },
    { value: 'queues', label: 'Queues' },
    { value: 'r2', label: 'R2' },
];

const GOOGLE_TABS = [{ value: 'adsense', label: 'Adsense' }];

function AdminInfrastructure({ cloud, onDeepLink }) {
    const [awsTab, setAwsTab] = useState('dashboard');
    const [cfTab, setCfTab] = useState('workers');
    const [googleTab, setGoogleTab] = useState('adsense');

    if (cloud === 'google') {
        return (
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <PillTabs value={googleTab} onChange={setGoogleTab} tabs={GOOGLE_TABS} />
                <Box sx={{ flex: 1, overflow: 'auto' }}>{googleTab === 'adsense' && <GoogleAdsense />}</Box>
            </Box>
        );
    }

    if (cloud === 'cloudflare') {
        return (
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <PillTabs value={cfTab} onChange={setCfTab} tabs={CF_TABS} />
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                    <CfInfrastructure tab={cfTab} />
                </Box>
            </Box>
        );
    }
    if (cloud === 'aws') {
        return (
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <PillTabs value={awsTab} onChange={setAwsTab} tabs={AWS_TABS} />
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                    {awsTab === 'templates' && <AwsTemplate />}
                    {awsTab === 'dashboard' && <AwsInstances onDeepLink={onDeepLink} />}
                </Box>
            </Box>
        );
    }
    return null;
}

export { AdminInfrastructure };
